<template>
  <div id="search-by-keyword" :class="{'is-unm': $store.getters.isUnmMain}" v-cloak>
    <div id="searchbar">
      <input type="text" v-model="searchKey" placeholder="Search">
      <i class="fas fa-search"></i>
    </div>

    <major-list :majors="filteredMajors"></major-list>
  </div>
</template>

<script>
  import MajorList from '../components/major_list'

  export default {
    name: 'KeywordSearch',

    data() {
      return {
        // searchKey: ''
        // majors: []
      }
    },

    computed: {
      searchKey: {
        get() {
          return this.$route.query.keyword
        },

        set(keyword) {
          this.$router.replace({
            name: 'nameSearch',
            query: {keyword: keyword}
          })
        }
      },

      // Filters majors based on their name and the search key
      filteredMajors() {
        let searchRegex = new RegExp(this.searchKey, 'i')
        return this.majors.filter((major) => {
          return searchRegex.test((major.program || {}).name) ||
                 searchRegex.test((major.program || {}).code) ||
                 searchRegex.test((major.concentration || {}).name) ||
                 searchRegex.test((major.concentration || {}).code)
        })
      },

      majors() {
        return this.$store.getters.currentMajors
      }

    },

    components: {
      'major-list': MajorList
    }
  }
</script>



// WEBPACK FOOTER //
// KeywordSearch.vue?35e0b276